// wrid - The unique ID of the response.
// wid - The widget ID. This is a unique, 6 character alphanumeric value.	abc123
// wty - The type of recommendation widget. The value returned in the API response shall be passed as a widget type.
interface BRWidgetViewData {
  wrid: string;
  wid: string;
  wty: string;
}
// item_id - The unique ID of the clicked product/ category/content/ item.
interface BRWidgetClickData extends BRWidgetViewData {
  item_id: string;
}

export const fireWidgetViewPixel = (widgetPayload: BRWidgetViewData) => {
  window?.dataLayer?.push({
    event: 'br_widget_view',
    brWidgetViewData: widgetPayload,
  });
};

export const fireWidgetClickPixel = (widgetPayload: BRWidgetClickData) => {
  window?.dataLayer?.push({
    event: 'br_widget_click',
    brWidgetClickData: widgetPayload,
  });
};

export const getBRRecommendationStoreKey = (
  recType: string,
  variables: Record<string, unknown>,
  countryCode: string | undefined
): string =>
  `${recType}:${JSON.stringify({
    ...variables,
    countryCode: countryCode?.toUpperCase(),
  })}`;

// products recs ab test - to be removed after experiment conclusion
export const PRODUCTS_RECS_AB_TEST_EXPERIMENT_ID = '4650418668568576';
export const PRODUCTS_RECS_AB_TEST_VARIATION_ID = '6664866409218048';
export const PRODUCTS_RECS_AB_TEST_PAGE_NAME = '18295143447_url_targeting_for_pdp_product_recs_test_2026';
export const PRODUCTS_RECS_AB_TEST_HEADERS = {
  'BR-Variation-Ids': 'br_recs_pdp_v2',
};
